<template>
  <hm-container>
    <div class="flex flex-between" slot="header">
      <div class="flex">
        <el-button size="small" type="primary" @click="approval">待审批</el-button>
        <el-button size="small" type="primary" @click="adopt">通 过</el-button>  
        <el-button size="small" type="primary" @click="noAdopt">不通过</el-button>
        <el-button size="small" type="primary" @click="allData">全 部</el-button>         
      </div>
      <div class="flex-1 text-right">
        <el-cascader
          v-model="searchCondition.catIdArray"
          :show-all-levels="false"
          size="small"
          class="mr10"
          :props="catProps"
          clearable
          :options="catList"
          placeholder="请选择标签分类"
        ></el-cascader>
        <el-input
          clearable
          style="width: 200px"
          v-model.trim="searchCondition.tagName"
          placeholder="请输入标签名称"
          size="small"
          class="ipt mr10"
        ></el-input>
        <el-button type="primary" size="small" @click="paging(1)"
          >查询</el-button
        >
      </div>
    </div>
    <div>
      <!-- <div class="flex flex-between item-center">
        <div>
          <span>已选{{ num }}条</span>
        </div>
        <div class="flex batch flex-end item-center">
          <div @click="batchSetting">
            <span class="delete-icon hmicon icon-xitong"></span>
            批量设置
          </div>
        </div>
      </div> -->
      <el-table
        stripe
        border
        ref="brandTable"
        @selection-change="getChecked"
        :data="list"
        style="width: 100%"
        id="table"
        size="small"
      >
        <!-- <el-table-column
          :selectable="checkSelectable"
          type="selection"
        ></el-table-column> -->
        <el-table-column
          type="index"
          label="序号"
          :index="index => index + (currentPage - 1) * pageSize + 1"
        ></el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="tagName"
          label="标签名称"
        ></el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="tagauditRemark"
          label="标签描述"
        ></el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="catName"
          label="标签分类"
        >
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="createBy"
          label="申请人"
        ></el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="auditState"
          label="审批状态"
        >
          <template v-slot="scope">
            <span class="success" v-if="scope.row.auditState === 'yes'"
              >已审批</span
            >
            <span class="gray" v-else-if="scope.row.auditState === 'auditing'"
              >待审批</span
            >
            <span class="danger" v-else>不通过</span>
          </template>
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="salesState"
          label="操作"
        >
          <template slot-scope="scope">
            <el-button
              size="small"
              type="text"
              class="blue"
              @click="toDetails(scope.row)"
              >查看详情</el-button
            >
            <el-button
              size="small"
              v-if="scope.row.auditState === 'auditing'"
              type="text"
              class="blue"
              @click="openAuditDialog(scope.row)"
              >审批</el-button
            >
            <!-- <el-button
              size="small"
              class="success"
              v-if="scope.row.auditState === 'auditing'"
              type="text"
              @click="audit(scope.row, 'yes')"
              >通过</el-button
            >
            <el-button
              size="small"
              class="danger"
              v-if="scope.row.auditState === 'auditing'"
              type="text"
              @click="audit(scope.row, 'no')"
              >不通过</el-button
            > -->
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="hm-pagination">
      <el-pagination
        background
        :total="total"
        @current-change="paging"
        @size-change="handleSizeChange"
        layout="total, sizes, prev, pager, next, jumper"
        :current-page="currentPage"
        :page-size="pageSize"
      ></el-pagination>
    </div>
    <el-dialog
      title="批量设置"
      :close-on-click-modal="false"
      :visible.sync="dialogVisible"
    >
      <el-form :rules="rules" ref="ruleForm" :model="ruleForm">
        <el-form-item label="审核状态">
          <el-radio-group v-model="ruleForm.auditState" prop="auditState">
            <el-radio label="yes">通过</el-radio>
            <el-radio label="no">不通过</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="备注" prop="auditRemark">
          <el-input
            type="textarea"
            :autosize="false"
            show-word-limit
            maxlength="100"
            v-model="ruleForm.auditRemark"
            placeholder="请输入备注"
          />
        </el-form-item>
        <el-form-item>
          <div class="flex flex-center">
            <el-button @click="submit('ruleForm')" type="primary" size="small"
              >确认</el-button
            >
            <el-button @click="dialogVisible = false" size="small"
              >关闭</el-button
            >
          </div>
        </el-form-item>
      </el-form>
    </el-dialog>
    <create-tag
      v-if="drawerVisible"
      :drawerVisible="drawerVisible"
      :tagDetails="tagDetails"
      disabled
      audit
      @audit="audit"
      @closeDrawer="drawerVisible = false"
    ></create-tag>
  </hm-container>
</template>

<script>
import createTag from "@/views/portraitLabelMgt/modules/createTag";

export default {
  components: {
    createTag
  },
  data() {
    return {
      tagDetails: {},
      drawerVisible: false,
      ruleForm: {
        auditState: "yes",
        auditRemark: ""
      },
      rules: {
        auditRemark: {
          required: true,
          message: "请输入备注",
          trigger: "blur"
        }
      },
      num: 0,
      list: [],
      total: 0,
      dialogVisible: false,
      checkedRow: [],
      searchCondition: {
        catIdArray: [],
        tagName: ""
      },
      oldRecord: null,
      currentPage: 1,
      pageSize: 10,
      catProps: {
        value: "id",
        label: "catName",
        checkStrictly: true
      },
      catList: []
    };
  },
  created() {
    this.queryList();
    this.queryAllTag();
  },
  watch: {},
  methods: {
    async openAuditDialog(row) {
      const { result } = await this.$store.dispatch("queryTagDetails", {
        id: row.id
      });
      this.tagDetails = result;
      this.drawerVisible = true;
      this.currentRow = row;
    },
    checkSelectable(row) {
      return row.auditState === "auditing";
    },
    // 待审批
    approval(){
      this.oldRecord = 'auditing'
      this.queryList('auditing');
    },
    // 通过
    adopt(){
      this.oldRecord = 'yes'
      this.queryList('yes');
    },
    // 不通过
    noAdopt(){
      this.oldRecord = 'no'
      this.queryList('no');
    },
    allData(){
      this.oldRecord = ''
      this.queryList();
    },
    async queryAllTag() {
      if (this.activeTab === "recycleBin") return;
      const { result } = await this.$store.dispatch("queryAllTagCat");
      this.catList = result;
    },
    async submit(formName) {
      await this.$refs[formName].validate();
      await this.$store.dispatch("auditTag", {
        ids: this.checkedRow.map(v => v.skuId),
        auditStatus: this.ruleForm.auditState,
        auditRemark: this.ruleForm.auditRemark
      });
      this.$message({
        type: "success",
        message: "操作成功"
      });
      this.dialogVisible = false;
     this.queryList(this.oldRecord);
    },
    async audit(auditStatus) {
      let text = "不通过";
      let message = "操作成功";
      if (auditStatus === "yes") {
        text = "通过";
        message =
          "标签已审批通过，每次凌晨自动与真实数据匹配，明日可查看标签详细结果";
      }
      const result = await this.$confirm(`是否${text}标签`, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      });
      if (result === "confirm") {
        await this.$store.dispatch("auditTag", {
          ids: [this.currentRow.id],
          auditStatus
        });
        this.$message({
          type: "success",
          message
        });
        this.drawerVisible = false;
        this.queryList(this.oldRecord);
      }
    },
    async queryList(State) {
      const { result } = await this.$store.dispatch("queryTagList", {
        pageSize: this.pageSize,
        pageNo: this.currentPage,
        tagName: this.searchCondition.tagName,
        tagCat: this.searchCondition.catIdArray[0],
        auditState: State
      });
      const { records, total } = result;
      this.list = records;
      this.total = total;
    },
    toDetails(row) {
      this.$router.push({
        name: "TagDetails",
        query: {
          id: row.id
        }
      });
    },
    handleSizeChange(size) {
      this.currentPage = 1;
      this.pageSize = size;
      this.queryList(this.oldRecord);
    },
    formatJson(filterVal, jsonData) {
      return jsonData.map(v => filterVal.map(j => v[j]));
    },
    switchAuditState(id, enabledState) {
      this.$store
        .dispatch("switchAuditState", {
          enabledState,
          id
        })
        .then(() => {
         this.queryList(this.oldRecord);
        });
    },
    addActivity() {
      this.$router.push({
        name: "SelectActivity"
      });
    },
    paging(page) {
      this.currentPage = page;
      this.queryList(this.oldRecord);
    },
    getChecked(selection) {
      this.checkedRow = selection;
      this.num = selection.length;
    },
    batchSetting() {
      if (this.checkedRow.length) {
        this.dialogVisible = true;
      } else {
        this.$message({
          message: "请选择",
          type: "warning"
        });
      }
    }
  }
};
</script>

<style scoped lang="scss">
.batch {
  div {
    margin: 20px 0;
    cursor: pointer;
    font-size: 14px;
    color: #222222;
    user-select: none;
    &:first-child {
      margin-right: 20px;
    }
  }
  .hmicon {
    margin-right: 5px;
  }
}

.tabs {
  .title {
    color: #222222;
    padding-left: 10px;
  }
  .tips {
    color: #666;
    font-size: 12px;
    padding-left: 10px;
  }
}
.tips {
  color: #999;
  font-size: 14px;
}
</style>
